<template>
  <div class="container mt40">
    <div class="common-detail-content">
      <!-- 上半部 -->
      <div class="content-box">
        <div class="banner-box">
          <div class="left">
            <div class="banner">
              <el-carousel ref="carousel" :interval="5000" arrow="always" height="356px" :initial-index="bannerIdx">
                <el-carousel-item v-for="(item,index) in banners" :key="index">
                  <img :style="{width: '100%', height: '100%'}" :src="item" alt="">
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="banner-label">
              <div :class="['banner-label-item', bannerActiveIdx == 0 ? 'active' : '']" @click="bannerChange(0)">全部图片({{info.bannerTotalNum || 0}})</div>
              <template v-if="info.bannerList.length > 0">
                <div :class="['banner-label-item', bannerActiveIdx === index + 1 ? 'active' : '']" v-for="(item, index) in info.bannerList" :key="index" @click="bannerChange(index + 1)">{{item.title}}({{item.imgList.length}})</div>
              </template>
            </div>
          </div>

          <div class="right">
            <div class="title">
              <div class="title-name">{{info.name}}</div>
              <div class="title-label">{{info.packageTicketLevel}}</div>
            </div>
            <div class="score">
              <div class="score-start">
                <div class="star-box" v-for="(star, starIdx) in 5" :key="starIdx">
                  <div class="star-icon1"></div>
                  <div :style="{width: info.avgReviewScore < star ? '0':(17 * (info.avgReviewScore - star+1) + 'px')}" class="star-icon2"></div>
                </div>
              </div>
              <div class="score-grade">{{info.avgReviewScore == null ? '暂无评' : info.avgReviewScore}}分</div>
              <div class="score-number">{{info.reviewTimes || 0}}</div>
              <div class="score-text">人评论</div>
            </div>
            <div class="contactway">
              <div class="contactway-item">
                <div class="label">景点地址:</div>
                <div class="text">
                  {{info.addressDetails}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">开放时间:</div>
                <div class="text">
                  {{info.openingTime}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">联系方式:</div>
                <div class="text">
                  {{info.phone ? info.phone : '暂无联系方式'}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">景点介绍:</div>
                <div class="text">
                  <p :class="{'show-all': showAll===true}">{{info.synopsis}}</p>
                  <span class="btn" @click="handleShow">{{showAll?'点击收起':'查看全部'}}</span>
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">人均消费:</div>
                <div class="price">
                  ￥{{info.consumptionPerPerson || 0}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flat-pattern">
          <div class="left-arrows" :class="{disabled: banners.length <= 6 || moveLeft === 0}" @click="handleBannerPrev"></div>
          <div class="img-list">
            <div class="img-box" :style="{left: -moveLeft + 'px'}">
              <div class="img-item" v-for="(item,index) in banners" :key="index">
                <img :src="item" alt="" @click="bannerIdxSel(index)">
              </div>
            </div>
          </div>
          <div class="right-arrows" :class="{disabled: banners.length <= 6 || moveLeft === (banners.length - 6) * imgHeight}" @click="handleBannerNext"></div>
        </div>
      </div>

      <!-- 中间 -->
      <div class="content-box">
        <div class="body-nav">
          <navTab :navList="navList" :tabPage="tabPage" :showDivider="true" @handleTabPage="handleTabPage"/>

          <div v-if="tabPage === 0" class="body-list">
            <div class="categories">
              <span v-for="(item, index) in categoryList" :key="index" :class="item.selected ? 'active' : ''" @click="handleTabCategory(item)">{{item.categoryName}}</span>
            </div>
            <template v-if="proList.length > 0">
              <div class="body-item" v-for="item in proList" :key="item.goodsId">
                <div class="left">
                  <div class="left-img"><img :src="item.mainPic" alt=""></div>
                  <div class="left-right">
                    <div class="right-title">{{item.goodsName}}</div>
                    <div class="right-rule" @click="reservationNotesVisible = true">预订须知 ></div>
                    <el-dialog
                      title=""
                      :visible.sync="reservationNotesVisible"
                      width="40%"
                      :show-close="true">
                        <div class="richContent" v-html="getRichContent(item.reservationNotes)"></div>
                    </el-dialog>
                    <div v-for="subItem in item.packagesGoodsItemVOList" :key="subItem.id" class="right-label">

                      <div class="label-item w170">
                        <span><strong>{{subItem.subGoodsName}}</strong></span>
                      </div>
                      <div class="label-item w170">
                        <span>{{subItem.subGoodsTargetName}}</span>
                      </div>
                      <div class="label-item">
                        <span>门市价￥{{subItem.subGoodsTargetSalePrice?(subItem.subGoodsTargetSalePrice).toFixed(2):'0'}}</span>
                      </div>
                      <div class="label-item">
                        <span>{{subItem.subGoodsTargetQuantity}}{{subItem.subModuleType=='HOTEL'?"晚":'张'}}</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="rigth-box">
                    <span class="sale-price"><span class="font-sm">¥</span>{{item.salePrice || 0}}</span>
                    <span class="goods-price" v-if="item.goodsPrice != null"><span class="font-sm">¥</span>{{item.goodsPrice || 0}}</span>
                  </div>
                  <div class="right-btn pointer" @click="handleToBook(item.goodsId,item.goodsName,item.salePrice)">立即预订</div>
                </div>
              </div>
            </template>
            <div v-else class="no-data">暂无数据</div>
          </div>

          <div v-if="tabPage === 1" class="body-list">
            <div class="title">景点介绍</div>
            <div class="text richContent" v-html="getRichContent(info.introduce)"></div>
          </div>
        </div>
      </div>

      <!-- 点评 -->
      <div class="content-box remark">
        <div class="information">
          <div class="titile">网友点评({{totalCount}})</div>
          <div class="comment-box">
            <div class="comment-list" v-for="item in commentList" :key="item.id">
              <div class="flex floor">
                <img :src="item.avatarUrl"/>
                <div class="com-name">
                  <div class="name">{{item.crtName}}</div>
                  <el-rate v-model="item.score" disabled show-score text-color="#FF0000" :score-template="item.score+'分'"/>
                </div>
                <div class="com-date">{{item.crtTime}}</div>
              </div>
              <div class="com-content">
                {{item.content}}
                <div class="img-comm">
                    <img v-for="(imgs,index) in item.pictures" :key="index" :src="imgs.url"/>
                </div>
                <div class="reply" v-if="item.replyContent">
                  <span class="lare">商家回复:</span>
                  {{item.replyContent}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="pagination-self">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout="prev, pager, next"
            :total="totalCount"
            @current-change="handleCurrentChangeCommen"
            :page-size="10"
            >
          </el-pagination>
        </div>
      </div>

    </div>
    <!-- 预订须知 -->
  </div>
</template>

<script>
import NavTab from '@/components/navTab'
import { loadInfo, saleList, loadCommentList, loadGoodsCategory } from '@/api/packageTicket/packageTicketDetail'

import { richTextWrap } from '@/common/js/utils'
import { queryDetailMixin } from '@/mixins/queryDetailMixin'
import { config } from '@/constant/config'
export default {
  mixins: [queryDetailMixin],
  data () {
    return {
      moduleType: 'PACKAGES',
      grade: 3.5,
      navList: ['套票预定', '套票介绍'],
      reservationNotesVisible: false,
      commentList: [],
      showAll: false,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      limit: 10,
      bedTypeList: [],
      categoryList: []
    }
  },
  components: {
    'navTab': NavTab
  },
  created () {
    this.loadCommentList()
    this.loadGoodsCategory()
  },
  methods: {
    // 加载产品类别
    loadGoodsCategory () {
      const param = {
        limit: 200,
        merchId: config.MERCHID,
        page: 1,
        tenantId: config.TENANTID
      }
      loadGoodsCategory(param).then(res => {
        if (res.code === 0) {
          this.categoryList = res.data.list.map(item => {
            item.selected = false
            return item
          })
        } else {
          this.$message.error(res.error)
        }
      })
    },
    // 富文本处理
    getRichContent (content) {
      if (content && typeof (content) === 'string') {
        const regexPre = new RegExp('pre>', 'g')
        content = content.replace(regexPre, 'div>')
      }
      return content
    },
    handleToBook (packageTicketId, packageTicketName, salePrice) {
      console.log('packageTicketId', packageTicketId)
      const packageTicketInfo = {
        viewPointName: this.info.name,
        packageTicketName,
        salePrice
      }
      this.$router.push({ path: 'packageTicketBook', query: { packageTicketId, packageTicketInfo: JSON.stringify(packageTicketInfo) } })
    },
    loadInfo () {
      loadInfo(this.id).then(res => {
        if (res.code === 0) {
          const obj = res.data
          // 景点类型处理
          obj.packageTicketLevel = obj.level + 'A'
          obj.reservationNotes = richTextWrap(obj.reservationNotes) || '暂无'
          this.loadIndustryOrMerchData(obj)
        }
      })
    },
    loadProducts () {
      const data = {
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        merchIndustryId: this.id,
        goodsCategoryId: this.goodsCategoryId
      }
      saleList(data).then(res => {
        this.loadList(res.data || [])
      })
    },
    handleCurrentChangeCommen (val) {
      this.page = val
      this.loadCommentList()
    },
    // 切换产品类别
    handleTabCategory (item) {
      this.categoryList.forEach(category => {
        if (category.id === item.id) {
          category.selected = !item.selected
          if (category.selected) {
            this.goodsCategoryId = item.id
          } else {
            this.goodsCategoryId = null
          }
        } else {
          category.selected = false
        }
      })
      console.log(this.categoryList)
      this.loadProducts()
    },
    handleShow () {
      this.showAll = !this.showAll
    },
    loadCommentList () {
      const data = {
        limit: this.limit,
        page: this.page,
        merchIndustryId: this.id
      }
      loadCommentList(data).then(res => {
        if (res.code === 0) {
          this.commentList = res.data.list
          this.commentList.forEach(listItem => {
            listItem.pictures = listItem.pictures ? JSON.parse(listItem.pictures) : []
          })
          this.totalPage = res.data.totalPage
          this.totalCount = res.data.totalCount
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.container {
  width: 1279px;
  overflow-x: auto;
}
.w170{
  width:170px !important
}
.right-label{
  width: 100% !important;
  margin-bottom: 16px;
}

.categories {
  margin-bottom: 40px;
  font-size: 0;
  span {
    display: inline-block;
    margin-right: 16px;
    padding: 0 15px;
    height: 28px;
    border: 1px solid #95A3AF;
    border-radius: 4px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #95A3AF;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    &.active{
      background: #9B232A;
      color: #fff;
      border-color: #9B232A;
    }
  }
}

</style>
